export const mutations = {
  STORE_DRIVERS(state, drivers) {
    state.drivers = drivers;
  },
  STORE_DRIVER_UPDATE(state, driverId) {
    let Driver = state.drivers.find(function(drivers) {
      return drivers.id === driverId;
    });
    state.systemDriver = Driver;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/drivers/mutations.js